module.exports = __webpack_public_path__ + "static/media/mealtrist-logo.0dc7edce.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mealtrist-logo.png
// module id = 41
// module chunks = 0